import { useMapPanelHeaderOverrides } from './hooks/useMapPanelHeaderOverrides'
import Content from './parts/Content'
import { Layout } from '@/features/layout/types'
import { FC } from 'react'
import { Platform, StyleSheet, View } from 'react-native'

interface MapPanelProps {
    layout: Layout
    visible: boolean
    onClose: () => void
    onOrderPress: (id: string) => void
}

const MapPanel: FC<MapPanelProps> = ({ layout, visible, onClose, onOrderPress }) => {
    const compact = layout === 'compact'

    useMapPanelHeaderOverrides({ enabled: compact && visible, onClose })

    return (
        <View
            style={[styles.panel, compact && styles.compact, !visible && styles.hidden]}
            pointerEvents={visible ? 'auto' : 'none'}
            accessibilityElementsHidden={!visible}
            importantForAccessibility={visible ? 'auto' : 'no-hide-descendants'}
        >
            {(Platform.OS === 'web' || visible) && (
                <Content hidden={!visible} layout={layout} onOrderPress={onOrderPress} />
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    panel: { flex: 1, minWidth: 0 },
    compact: StyleSheet.absoluteFillObject,
    hidden: { display: 'none' },
})

export default MapPanel
